import { trackRedirectEvent } from '@tracking';
import getWindow from '../shared/dom/getWindow';
import { logError, logInfo, logWarning } from '../shared/logger';
import type { Redirect } from '../shared/types/Redirect';

const DISABLE_REDIRECT_KEY = 'TPS_DISABLE_REDIRECT';
const DELAY_TILL_REDIRECT_IN_GHOST_MODE = 0;
const DELAY_TILL_REDIRECT = 1000;

export const isRedirectDisabled = (window: Window, url: string): boolean => {
  try {
    const disableFromUrl = window.location.href?.includes?.(DISABLE_REDIRECT_KEY);
    const disableFromStorage = window.sessionStorage?.getItem?.(DISABLE_REDIRECT_KEY);

    if (disableFromUrl || disableFromStorage === 'true') {
      logWarning(`Redirect disabled for: ${url}`);

      return true;
    }
  } catch (error) {
    const message = (error && (error as Error)?.message) || 'Unknown';

    logError(`Redirect state check failed with error: ${message}`);
  }

  return false;
};

const redirectTo = (
  url: string,
  redirect: Redirect,
  isGhostMode?: boolean,
  customTimeout?: number,
): NodeJS.Timeout => {
  const window = getWindow();
  const timeout = isGhostMode
    ? DELAY_TILL_REDIRECT_IN_GHOST_MODE
    : customTimeout || DELAY_TILL_REDIRECT;

  logInfo(`Redirect scheduled in ${timeout}ms (ghostMode: ${isGhostMode ?? false})`, { campaign: redirect.campaign });

  const redirectTimer = setTimeout(() => {
    trackRedirectEvent(redirect);

    if (window) {
      logInfo('Redirect fired', { campaign: redirect.campaign });
      window.location.replace(url);
    }
  }, timeout);
  return redirectTimer;
};

export default redirectTo;
